import { IPartnerRefIDsView } from 'clickNgo/models/crud/views/iPartnerRefIDsView'
import { IOrderManagementItem } from 'clickNgo/models/order'

export const mapOrderManagementItemFromPartnerRefIDs = (
  item: IPartnerRefIDsView
): IOrderManagementItem => {
  return {
    actionExt: item.ActionExt,
    entryId: item.EntryId,
    entryIdExt: item.EntryIdExt,
    partnerId: item.PartnerId,
    refId: item.RefId,
    refIdDescription: item.RefIdDescription,
    sourceExt: item.SourceExt,
    statusExt: item.StatusExt,
    systemId: item.SystemId,
    systemType: item.Systemtype,
  }
}
